module.exports = __webpack_public_path__ + "img/horarioFuncionamentoFill.c9415063.svg";